import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTbSmoothLgt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "14.75 34.75 50.5 2.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(4,0) scale(3)",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M 4,12 L 8,12 M 10,12 L 14,12 M 16,12 L 20,12",
			stroke: "white",
			strokeWidth: 2.5,
			fill: "none"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 4,12 L 8,12 M 10,12 L 14,12 M 16,12 L 20,12",
			stroke: "#00aa00",
			fill: "none"
		})]
	})
});
export default SvgTbSmoothLgt;
